import { ColumnKeys, ColumnTitles } from './enums'

export const columnTitleMap: Record<ColumnKeys, ColumnTitles> = {
  key: ColumnTitles.KEY,
  locationName: ColumnTitles.LOCATION,
  productName: ColumnTitles.PRODUCT,
  productSKU: ColumnTitles.SKU,
  parentCategoryName: ColumnTitles.CATEGORY,
  categoryName: ColumnTitles.SUB_CATEGORY,
  productVendorName: ColumnTitles.BRAND,
  inventoryQuantity: ColumnTitles.QUANTITY,
  productCost: ColumnTitles.UNIT_COST,
  productPrice: ColumnTitles.UNIT_PRICE,
  inventoryCost: ColumnTitles.TOTAL_COST,
  inventoryPrice: ColumnTitles.TOTAL_PRICE,
  margin: ColumnTitles.MARGIN,
}

export const columnKeyMap: Record<ColumnTitles, { val: ColumnKeys; cubeVal: string }> = {
  [ColumnTitles.KEY]: {
    val: ColumnKeys.KEY,
    cubeVal: '',
  },
  [ColumnTitles.LOCATION]: {
    val: ColumnKeys.LOCATION,
    cubeVal: 'Locations.name',
  },
  [ColumnTitles.PRODUCT]: {
    val: ColumnKeys.PRODUCT,
    cubeVal: 'Products.fullname',
  },
  [ColumnTitles.SKU]: {
    val: ColumnKeys.SKU,
    cubeVal: 'Products.sku',
  },
  [ColumnTitles.CATEGORY]: {
    val: ColumnKeys.CATEGORY,
    cubeVal: 'Categories.parentname',
  },
  [ColumnTitles.SUB_CATEGORY]: {
    val: ColumnKeys.SUB_CATEGORY,
    cubeVal: 'Categories.name',
  },
  [ColumnTitles.BRAND]: {
    val: ColumnKeys.BRAND,
    cubeVal: 'Suppliers.name',
  },
  [ColumnTitles.QUANTITY]: {
    val: ColumnKeys.QUANTITY,
    cubeVal: 'InventoryLog.newValue',
  },
  [ColumnTitles.UNIT_COST]: {
    val: ColumnKeys.UNIT_COST,
    cubeVal: 'InventoryLog.productCost',
  },
  [ColumnTitles.UNIT_PRICE]: {
    val: ColumnKeys.UNIT_PRICE,
    cubeVal: 'Products.overrideprice',
  },
  [ColumnTitles.TOTAL_COST]: {
    val: ColumnKeys.TOTAL_COST,
    cubeVal: 'InventoryLog.cost',
  },
  [ColumnTitles.TOTAL_PRICE]: {
    val: ColumnKeys.TOTAL_PRICE,
    cubeVal: 'InventoryLog.price',
  },
  [ColumnTitles.MARGIN]: {
    val: ColumnKeys.MARGIN,
    cubeVal: 'InventoryLog.margin',
  },
}

export const columnTitleTooltipMap = {
  [ColumnTitles.UNIT_PRICE]: 'Current retail price',
  [ColumnTitles.TOTAL_PRICE]: 'Calculated from current retail price',
}
